"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_ZHCN_TRANS = {
    'time picker': '时间',
    'today': '今天',
    'set time': '设置时间',
    'close': '关闭',
    'cancel': '取消',
    'confirm': '确认',
    'hour': '时',
    'minute': '分',
    'second': '秒',
};
//# sourceMappingURL=zh-cn.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng-pick-datetime/locale/zh-cn.js
// module id = ../../../../ng-pick-datetime/locale/zh-cn.js
// module chunks = 18